import { SharingInfo } from '@models/sharingInfo';
import { Model } from '../model';
import { Paginated } from '../paginated';

export class ContactGroup extends Model {
  id?: string;
  name: string;
  description: string;
  sharingInfo?: SharingInfo;
}

export class ContactGroups extends Paginated {
  data: Array<ContactGroup>;
}

export class ContactGropsSearchFilter extends Model {
  nameStartsWith?: string;
  countContacts: boolean;
  excludeSharingInfo: boolean;
  onlyOwnedGroups: boolean;
}
